import type { Cable } from "./types";

/** Stored in the existing cable notes so the limitation survives project
 * saves, copies and older file readers without changing the file schema. */
export const CONNECTION_OVERVIEW_NOTES = "Connection overview only. Cable lengths are placeholders; use the complete manufacturer diagram to select conductors and protection. No automatic fuse or cable-size recommendation is supplied by this example.";

/** This connection is hardware contact, not a conductor awaiting sizing. Keep
 * the persisted marker independent of labels and node ids so copies and saved
 * projects cannot offer a cable calculation for a direct terminal attachment. */
export const DIRECT_TERMINAL_MOUNT_NOTES = `${CONNECTION_OVERVIEW_NOTES} Direct terminal mount only. No cable exists at this connection; the zero-length link represents mechanical and electrical contact at the battery terminal.`;

export function isDirectTerminalMount(cable: Pick<Cable, "notes"> | undefined): boolean {
  return cable?.notes?.startsWith(DIRECT_TERMINAL_MOUNT_NOTES) ?? false;
}

export function isConnectionOverviewCable(cable: Pick<Cable, "notes"> | undefined): boolean {
  return cable?.notes?.startsWith(CONNECTION_OVERVIEW_NOTES) ?? false;
}

export function withoutConnectionOverview(cable: Pick<Cable, "notes">): string | undefined {
  if (isDirectTerminalMount(cable)) return cable.notes;
  if (!isConnectionOverviewCable(cable)) return cable.notes;
  return cable.notes!.slice(CONNECTION_OVERVIEW_NOTES.length).trim() || undefined;
}
